import React from 'react';

import { connect } from 'react-redux';
import { Container } from 'reactstrap';

import '../NavMenu/NavMenu.css';
import SyncfusionDialogUtilityHelper from 'components/Common/SyncfusionDialogUtilityHelper';

import DialogPlaceholder from '../Common/DialogPlaceholder';
import GlobalDialogWithLocation from '../Common/GlobalDialogWithLocation';
import Notification from '../Common/Notification';
import PopupWindow from '../Common/PopupWindow';
import VirtualVisitModal from '../Common/VirtualVisits/VirtualVisitModal';
import NavMenu from '../NavMenu/NavMenu';
import Footer from './Footer';
import Header from './Header';
class Layout extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Header />
                <NavMenu />
                <div>
                    <div className="main-content">
                        <Container data-testid='container'>{this.props.children}</Container>
                        <Notification />
                        <GlobalDialogWithLocation />
                        <DialogPlaceholder />
                        <PopupWindow />
                        <SyncfusionDialogUtilityHelper  />
                    </div>
                    <Footer />
                </div>
                <VirtualVisitModal />
            </React.Fragment>
        );
    }
}

export { Layout as UnconnectedLayout };
export default connect()(Layout);
